module.exports = __webpack_public_path__ + "media/content-creator/pets-1-cee8417a.png";